import React from 'react';
import {
  AUTH_PATH_PREFIX,
  APP_PATH_PREFIX,
  PUBLIC_PATH_PREFIX,
} from './AppConfig';

// Auth routes - redirect to home if already authenticated
export const authRoutes = [
  {
    key: 'login',
    path: `${AUTH_PATH_PREFIX}/login`,
    component: React.lazy(() => import('../views/auth-views/login')),
  },
  {
    key: 'forgot-password',
    path: `${AUTH_PATH_PREFIX}/forgot-password`,
    component: React.lazy(() => import('../views/auth-views/forgot-password')),
  },
];

// Public routes - accessible to everyone (authenticated or not)
export const publicRoutes = [
  {
    key: 'mrf-public-approval',
    path: `${PUBLIC_PATH_PREFIX}/mrf-approval`,
    component: React.lazy(() => import('../views/public-views/MRFPublicApproval')),
  },
  {
    key: 'interview-feedback-public',
    path: `${PUBLIC_PATH_PREFIX}/interview-feedback`,
    component: React.lazy(() => import('../views/public-views/InterviewFeedbackForm')),
  },
  {
    key: 'pre-joining-form-public',
    path: `${PUBLIC_PATH_PREFIX}/pre-joining-form`,
    component: React.lazy(() => import('../views/public-views/PreJoiningForm')),
  },
];
export const protectedRoutes = [
  {
    key: 'home',
    path: `${APP_PATH_PREFIX}/home`,
    component: React.lazy(() => import('../views/app-views/home')),
  },
  {
    key: 'change-password',
    path: `${APP_PATH_PREFIX}/change-password`,
    component: React.lazy(() => import('../views/auth-views/change-password')),
  },
  {
    key: 'profile',
    path: `${APP_PATH_PREFIX}/profile`,
    component: React.lazy(() => import('../views/app-views/profile')),
  },
  {
    key: 'USER',
    path: `${APP_PATH_PREFIX}/manage-user`,
    component: React.lazy(() => import('../views/app-views/user')),
  },
  {
    key: 'role',
    path: `${APP_PATH_PREFIX}/role`,
    component: React.lazy(() => import('../views/app-views/roles')),
  },
  // --------------------------In-App Admin Screen--------------------------
  {
    key: 'Manage-Users',
    path: `${APP_PATH_PREFIX}/manage-users`,
    component: React.lazy(() => import('../views/app-views/ManageUsers')),
  },
  // -------------------------HR Module — Phase 1: MRF-------------------------
  {
    key: 'MRF',
    path: `${APP_PATH_PREFIX}/hr/mrf`,
    component: React.lazy(() => import('../views/app-views/HR/mrf/MRFList')),
  },
  {
    key: 'MRF-New',
    path: `${APP_PATH_PREFIX}/hr/mrf/new`,
    component: React.lazy(() => import('../views/app-views/HR/mrf/MRFForm')),
  },
  {
    key: 'MRF-Edit',
    path: `${APP_PATH_PREFIX}/hr/mrf/edit/:id`,
    component: React.lazy(() => import('../views/app-views/HR/mrf/MRFForm')),
  },
  {
    key: 'MRF-Detail',
    path: `${APP_PATH_PREFIX}/hr/mrf/:id`,
    component: React.lazy(() => import('../views/app-views/HR/mrf/MRFDetail')),
  },
  // -------------------------HR Module — Phase 2: Candidates-------------------------
  {
    key: 'Add Candidate',
    path: `${APP_PATH_PREFIX}/hr/candidates/add`,
    component: React.lazy(() => import('../views/app-views/HR/candidates/CandidateEntry')),
  },
  {
    key: 'CV Shortlisting',
    path: `${APP_PATH_PREFIX}/hr/candidates`,
    component: React.lazy(() => import('../views/app-views/HR/candidates/CVShortlisting')),
  },
  {
    key: 'CV Shortlisting',
    path: `${APP_PATH_PREFIX}/hr/candidates/:mrf_id`,
    component: React.lazy(() => import('../views/app-views/HR/candidates/CVShortlisting')),
  },
  // -------------------------HR Module — Phase 3: Interviews-------------------------
  {
    key: 'Interviews',
    path: `${APP_PATH_PREFIX}/hr/interviews`,
    component: React.lazy(() => import('../views/app-views/HR/interviews/InterviewList')),
  },
  // -------------------------HR Module — Phase 4: Offers & Onboarding-------------------------
  {
    key: 'Offers',
    path: `${APP_PATH_PREFIX}/hr/offers`,
    component: React.lazy(() => import('../views/app-views/HR/offers/OfferList')),
  },
  {
    key: 'Offer-Detail',
    path: `${APP_PATH_PREFIX}/hr/offers/:id`,
    component: React.lazy(() => import('../views/app-views/HR/offers/OfferDetail')),
  },
  {
    key: 'Create-Offer-Letter',
    path: `${APP_PATH_PREFIX}/hr/offers/:id/create-letter`,
    component: React.lazy(() => import('../views/app-views/HR/offers/CreateOfferLetter')),
  },
  {
    key: 'HOD-Dashboard',
    path: `${APP_PATH_PREFIX}/hr/hod-dashboard`,
    component: React.lazy(() => import('../views/app-views/HR/dashboard/HODDashboard')),
  },
  // -------------------------HR Module — Approvals Inbox-------------------------
  {
    key: 'Approvals',
    path: `${APP_PATH_PREFIX}/hr/approvals`,
    component: React.lazy(() => import('../views/app-views/HR/approvals/ApprovalsInbox')),
  },
  // -------------------------HR Module — Approval Mapping-------------------------
  {
    key: 'Approval-Mapping',
    path: `${APP_PATH_PREFIX}/hr/approval-mapping`,
    component: React.lazy(() => import('../views/app-views/HR/approval-mapping')),
  },
  // -------------------------HR Module — Phase 6: Position Budget Master-------------------------
  {
    key: 'Position-Budget',
    path: `${APP_PATH_PREFIX}/hr/position-budget`,
    component: React.lazy(() => import('../views/app-views/HR/budget/PositionBudgetList')),
  },
  // -------------------------HR Module — JD Library-------------------------
  {
    key: 'JD-Library',
    path: `${APP_PATH_PREFIX}/hr/jd-library`,
    component: React.lazy(() => import('../views/app-views/HR/jd/JDLibraryList')),
  },
  // -------------------------HR Module — Master Data-------------------------
  {
    key: 'Master-Data',
    path: `${APP_PATH_PREFIX}/hr/master-data`,
    component: React.lazy(() => import('../views/app-views/HR/master-data')),
  },
  // -------------------------HR Module — Phase 5: Dashboards & Analytics-------------------------
  {
    key: 'Dashboard',
    path: `${APP_PATH_PREFIX}/hr/dashboard`,
    component: React.lazy(() => import('../views/app-views/HR/dashboard/HRDashboard')),
  },
  {
    key: 'Analytics',
    path: `${APP_PATH_PREFIX}/hr/analytics`,
    component: React.lazy(() => import('../views/app-views/HR/dashboard/HRAnalytics')),
  },
  {
    key: 'Budget-Dashboard',
    path: `${APP_PATH_PREFIX}/hr/budget-dashboard`,
    component: React.lazy(() => import('../views/app-views/HR/dashboard/HRBudgetDashboard')),
  },
];
